import { base } from '../base';

export const headerHeight = base(4);

export const contentWidth = '1600px';

export const modalWidth = 800;
